import { createSlice } from '@reduxjs/toolkit'
import englishStrings from '../../lang/en.json';
import italianStrings from '../../lang/it.json';

let initialState = {
    currentLanguage: localStorage.getItem('currentLanguage') || 'it'
};
if(initialState.currentLanguage == 'en') {
    initialState.strings = englishStrings;
} else if(initialState.currentLanguage == 'it') {
    initialState.strings = italianStrings;
}

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
      languageChanged(state, action) {
          let newLanguage = action.payload.language;
          state.currentLanguage = newLanguage;
          switch(newLanguage) {
              case 'en':
                  state.strings = englishStrings;
                  break;
              case 'it':
                  state.strings = italianStrings;
                  break;
          }
          localStorage.setItem('currentLanguage', newLanguage);
      }
  }
});
export const { languageChanged } = languageSlice.actions;
export const selectAllStrings = (state) => state.language.strings;
export const selectCurrentLanguage = (state) => state.language.currentLanguage;

export default languageSlice.reducer